import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
export const FormGroup = (props) => {
    const containerClass = [props.className || '', css(styles.container)].join(' ');
    return React.createElement("div", { className: containerClass }, props.children);
};
const styles = StyleSheet.create({
    container: {
        marginBottom: '0.75rem',
    },
});
